// import 'element-closest/browser';

export default class openVideo {
    constructor() {
        this.containers = document.querySelectorAll('.cp-hp-banner-evenement');
        if (this.containers === null) return;


        this.btnsOpen = document.querySelectorAll(".btn-open-video");

        this.init()

    }


    init(){
        this.btnsOpen.forEach((btn) => {
            const videoType = btn.getAttribute('data-type');


            btn.addEventListener('click', () => {
                
                if(videoType == "yt"){
                    const videoItem = btn.closest('.cp-hp-banner-evenement').querySelector('.video-item-yt');
                    const iframeID = videoItem.querySelector('.video-wrapper .player-yt').getAttribute('id');
                    const videoID = videoItem.querySelector('.video-wrapper .player-yt').getAttribute('data-video-id');
     
                    const video = new YT.Player(iframeID, {
                        height: '670',
                        width: '1600',
                        videoId: videoID,
                        mute: 1,   
                    })
                    
                    videoItem.classList.add('show');          
                    video.playVideo()

                }else {
                    const videoItem = btn.closest('.cp-hp-banner-evenement').querySelector('.video-item-mp4');
                    videoItem.classList.add('show');

                    const video = videoItem.querySelector('video')
                    video.play()
                }
            })
        })
    }
}
